var breakpointTokens = {
  xxs: 360,
  xs: 475,
  s: 720,
  m: 1020,
  l: 1200,
  xl: 1920
};
var breakpoint = {
  xxs: "@media (max-width: " + breakpointTokens.xxs + "px)",
  xs: "@media (max-width: " + breakpointTokens.xs + "px)",
  s: "@media (max-width: " + breakpointTokens.s + "px)",
  m: "@media (max-width: " + breakpointTokens.m + "px)",
  l: "@media (max-width: " + breakpointTokens.l + "px)",
  xl: "@media (max-width: " + breakpointTokens.xl + "px)"
};
// will standardise these later
var wrapperBreakpoints = {
  xs: 320,
  s: 375,
  sm: 414,
  m: 667,
  l: 768,
  lg: 991,
  xl: 1024,
  xxl: 1199
};
var medias = {
  /**
   * To Width sets
   */
  xsWidth: "@media only screen and (max-width: " + wrapperBreakpoints.xs + "px)",
  smWidth: "@media only screen and (max-width: " + wrapperBreakpoints.sm + "px)",
  /**
   * To Landscape sets
   */ // For content could not fit in small size phone like IPhone 5s / 6 / 6s
  smLandscape: "@media only screen and (orientation: landscape) and (max-height: " + wrapperBreakpoints.sm + "px)",
  /**
   * To Height sets
   */
  mHeight: "@media screen and (max-height: " + wrapperBreakpoints.m + "px)",
  lHeight: "@media screen and (max-height: " + wrapperBreakpoints.l + "px)",
  xlHeight: "@media screen and (max-height: " + wrapperBreakpoints.xl + "px)",
  /**
   * From sets
   */ // Very rare device to be handle like Iphone 5s
  beyondSm: "@media only screen and (min-width: " + (wrapperBreakpoints.sm + 1) + "px) and (min-height: " + (wrapperBreakpoints.sm + 1) + "px)",
  beyondM: "@media only screen and (min-width: " + (wrapperBreakpoints.m + 1) + "px) and (min-height: " + (wrapperBreakpoints.m + 1) + "px)",
  // Treat as desktop when screen big than Ipad
  beyondXl: "@media only screen and (min-width: " + (wrapperBreakpoints.xl + 1) + "px) and (min-height: " + (wrapperBreakpoints.l + 1) + "px)"
};
export { breakpoint, breakpointTokens, medias, wrapperBreakpoints };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJlYWtwb2ludHMuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
